function formatDate(savedDate) {
  return savedDate.split("-").reverse().join("-");
}

export function modifyDataBeforeSending(payload) {
  let customerData = {};
  // backend sends date in format: DD-MM-YYYY and
  // input type date expects: YYYY-MM-DD
  // so value needs to be modified
  Object.keys(payload).forEach((data) => {
    if (data === "fiForeignerBirthDate") {
      customerData["fiForeignerBirthDate"] = formatDate(
        payload["fiForeignerBirthDate"],
      );
    } else {
      customerData = {
        ...customerData,
        [data]: payload[data],
      };
    }
  });

  return customerData;
}

export const loadUserDataFromSession = () => {
  return (dispatch, getState, { api }) => {
    return api.getUserDataFromSession().then(
      (data) => {
        if (data.result) {
          const customer =
            data.result.customer &&
            modifyDataBeforeSending(data.result.customer);

          let registrant = data.result.registrant;
          if (registrant) {
            const { tldPersonData, ...restRegistrant } = registrant;

            registrant = modifyDataBeforeSending({
              ...restRegistrant,
              ...tldPersonData,
            });
          }

          return {
            wasSuccessful: true,
            data: {
              customer,
              registrant,
              isSame: data.result.isSame,
              preOrderCode: data.result.orderFlowData.preOrderCode,
              orderNumber: data.result.orderFlowData.orderNumber,
              orderCode: data.result.orderFlowData.orderCode,
              paymentType: data.result.orderFlowData.paymentType,
              userId: data.result.orderFlowData.hashedEmail,
            },
          };
        }

        return {
          wasSuccessful: false,
        };
      },
      (err) => {
        return { wasSuccessful: false };
      },
    );
  };
};
